export interface CaptionRevision {
  full: string;
  stable: string;
  changing: string;
}

export const emptyCaptionRevision = (): CaptionRevision => ({
  full: "",
  stable: "",
  changing: "",
});

export const splitStableCaption = (previous: string, next: string): CaptionRevision => {
  const nextWords = next.trim().split(/\s+/).filter(Boolean);
  const previousWords = previous.trim().split(/\s+/).filter(Boolean);
  let stableWordCount = 0;

  while (
    stableWordCount < previousWords.length
    && stableWordCount < nextWords.length
    && previousWords[stableWordCount] === nextWords[stableWordCount]
  ) {
    stableWordCount += 1;
  }

  return {
    full: nextWords.join(" "),
    stable: nextWords.slice(0, stableWordCount).join(" "),
    changing: nextWords.slice(stableWordCount).join(" "),
  };
};

export const completeWordsOnly = (text: string): string => {
  const lastBoundary = Math.max(text.lastIndexOf(" "), text.lastIndexOf("\n"), text.lastIndexOf("\t"));
  return lastBoundary < 0 ? "" : text.slice(0, lastBoundary).trim();
};
